import React from "react";
import RequestFrom from "./Components/RequestForm/RequestForm";

const SellRequestCreate = (props) => {
    return (
        <div>
            <RequestFrom />
        </div>
    );
};

export default SellRequestCreate;
